<template>
  <RouterLink id="dashboard-link" class="wrapper" to="dashboard">
    <div class="background">
      <div class="wrapper__item">
        <div class="background-gradient">
          <img alt="background" src="@/assets/banners/purple-background.svg" />
        </div>
        <img
          alt="dashboard"
          class="img"
          src="@/assets/banners/dashboard2x.png"
        />
        <div class="dashboard">
          <span class="dashboard-title">{{ $t('common.dashboard') }}</span>
          <span class="dashboard-text"
            >{{ $t('swap.earnPoints') }} &#11088;&#11088;&#11088;</span
          >
        </div>
      </div>
    </div>
  </RouterLink>
</template>
<script lang="ts" setup>
import { EMixpanelEventNames, EMixpanelProvideKeys } from '@/types/enums';
import { inject, onMounted } from 'vue';
import { TrackLinks } from '@/types';

const trackLinks = inject(EMixpanelProvideKeys.TrackLinks) as TrackLinks;

onMounted(() => {
  trackLinks('#dashboard-link', EMixpanelEventNames.BannerDashboard);
});
</script>
<style lang="scss" scoped>
.wrapper {
  display: block;
  width: 100%;
  height: 84px;
  padding: 0 5px 0 5px;
  border-radius: 10px;
  cursor: pointer;
  overflow: hidden;
  background: rgba(171, 174, 255, 0.13);

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  @media (max-width: 500px) {
    gap: 5px;
  }
}
.img {
  z-index: 1;
  margin-left: 10px;
  height: 68px;
  @media (max-width: 500px) {
    margin-left: 5px;
  }
}

.background {
  display: flex;
  align-items: center;
  width: 100%;
  height: 84px;
  background-image: url(@/assets/banners/tokens-bg.png);
  background-repeat: no-repeat;
  background-position: right bottom;
}

.dashboard {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
}

.dashboard-title {
  z-index: 1;
  font-family: Work Sans, sans-serif;
  font-size: 21px;
  font-weight: 700;
  line-height: 20.72px;
  color: white;
  margin-bottom: 5px;
}

.dashboard-text {
  z-index: 1;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: white;
}

.background-gradient {
  z-index: 0;
  position: absolute;
  width: 100%;
  height: 84px;
}
</style>
